import { Injectable } from '@angular/core';
import { BaseService } from '../../common/services/base.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable()
export class RightsService extends BaseService {

    constructor(private http: HttpClient) {
        super();
    }

    getRights(): Observable<string[]> {
        return this.http.get(this.getApiUrl() + '/rights/active')
            .pipe(map((res: any) => res?.rights || {}));
    }
}
